/** Format a sequential job number as a human-readable Job ID */
export function formatJobId(jobNumber: number | null | undefined): string {
  if (!jobNumber) return '';
  return `JOB-${String(jobNumber).padStart(4, '0')}`;
}
